import { Editor, Path, Transforms } from 'slate';

export const clearCoverage = (editor: Editor, path: Path): void => {
  Transforms.unsetNodes(editor, 'coverage' as string, { at: path });
};
